module.exports = "https://cdn-challenge.mathletics.com/app/282/assets/fonts/19b29984d782b315838f127af8295dde.woff2";